import { LogSeverity, StepExecutionLogs } from '@/types/stepExecutions.ts';

const LOG_MESSAGES_TO_SKIP = ['Starting step', 'Step completed', 'Step execution started'];

export const getRenderableStepExecutionLogs = (logs: StepExecutionLogs) =>
  // Hide only routine lifecycle messages. Diagnostics and linked artifacts
  // remain readable and must prevent a structured Activity fallback.
  logs.filter(
    (log) =>
      !LOG_MESSAGES_TO_SKIP.includes(log.message) ||
      (log.severity !== LogSeverity.Debug && log.severity !== LogSeverity.Info) ||
      Boolean(log.detail_message) ||
      Boolean(log.dataset),
  );
